export const CALL_TYPES = {
    VIDEO_CALL: "meeting",
    WEBINAR: "webinar",
};